import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export class ModelMutatorDate extends ModelMutator<FormModelField, CollectionModelFieldDate> {
	manual(newValue: string | null) {
		this.state.setFieldValue(this.field.id, newValue);
	}
}

export class CollectionModelFieldDate extends CollectionModelField<FormModelField, string> {
	static TYPE: IkeFieldType = IkeFieldType.DATE;

	static isDateField(f: CollectionModelField): f is CollectionModelFieldDate {
		return f.schema.type === CollectionModelFieldDate.TYPE;
	}

	private _Mutator: ModelMutatorDate;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorDate(this);
		}
		return this._Mutator;
	}
	override get value(): string {
		return this.stateValue;
	}

	hasValue() {
		const value = this.value;
		if (value == null || value === '') {
			return false;
		}
		return true;
	}
}

registerFieldType(IkeFieldType.DATE, (parent, schema) => new CollectionModelFieldDate(parent, schema));
